import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { SearchIcon, ShoppingBagIcon, MenuIcon, PhoneIcon, ChevronDownIcon, XIcon } from 'lucide-react';
export function Header() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const popularSearches = ['KENTE', 'BESPOKE', 'ACCESSORIES', 'WOMEN', 'MEN'];
  const megaMenuData = [{
    title: 'NEW & FEATURED',
    items: ['NEW IN', 'HIS & HERS', 'SALE'],
    images: [{
      url: 'https://cdn.magicpatterns.com/uploads/pJKfmPcBjErq76jQrTYk2j/image.png',
      label: 'New Arrivals'
    }, {
      url: 'https://cdn.magicpatterns.com/uploads/bxTL7vVABPe8YuDE1LiVeu/image.png',
      label: 'Best Sellers'
    }, {
      url: 'https://cdn.magicpatterns.com/uploads/tAhHTkZdpHhiBHvZ4nHim3/image.png',
      label: 'Lookbook'
    }]
  }, {
    title: 'COLLECTIONS',
    items: ['WOMEN', 'CURVE COLLECTION', 'MEN', 'UNISEX'],
    images: [{
      url: 'https://images.unsplash.com/photo-1617137984095-74e4e5e3613f?auto=format&fit=crop&q=80&w=600',
      label: 'Menswear'
    }, {
      url: 'https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=600',
      label: 'Womenswear'
    }, {
      url: 'https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=600',
      label: 'Bespoke'
    }]
  }, {
    title: 'FAMILY',
    items: ['DADDY & ME', 'MOMMY & ME', 'KIDS'],
    images: [{
      url: 'https://images.unsplash.com/photo-1622290291468-a28f7a7dc6a8?auto=format&fit=crop&q=80&w=600',
      label: 'Kids Collection'
    }, {
      url: 'https://images.unsplash.com/photo-1519233073511-01998bd4df00?auto=format&fit=crop&q=80&w=600',
      label: 'Mommy & Me'
    }, {
      url: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&q=80&w=600',
      label: 'Family Sets'
    }]
  }, {
    title: 'LIFESTYLE',
    items: ['ACCESSORIES', 'FABRIC', 'COQUETTE NATURAL SKIN CARE'],
    images: [{
      url: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=600',
      label: 'Jewelry'
    }, {
      url: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&q=80&w=600',
      label: 'Footwear'
    }, {
      url: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&q=80&w=600',
      label: 'Skin Care'
    }]
  }];
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-grey-divider" data-id="element-128">
      <div className="max-w-[1800px] mx-auto px-6 h-20 flex items-center justify-between relative" data-id="element-129">
        <div className="flex items-center space-x-6" data-id="element-130">
          <button onClick={() => setIsMobileMenuOpen(true)} className="md:hidden hover:opacity-50 transition-opacity" data-id="element-131">
            <MenuIcon className="w-5 h-5 stroke-[1.5px]" data-id="element-132" />
          </button>
          <a href="tel:5718423307" className="hidden md:flex items-center space-x-2 hover:opacity-50 transition-opacity" data-id="element-133">
            <PhoneIcon className="w-4 h-4 stroke-[1.5px]" data-id="element-134" />
            <span className="text-[9px] font-display tracking-widest uppercase" data-id="element-135">
              (571) 842-3307
            </span>
          </a>
        </div>

        <div className="absolute left-1/2 -translate-x-1/2" data-id="element-136">
          <Link to="/" data-id="element-137">
            <h1 className="text-xl md:text-2xl font-display font-bold tracking-[0.4em] uppercase" data-id="element-138">
              Djili
            </h1>
          </Link>
        </div>

        <div className="flex items-center space-x-6" data-id="element-139">
          <button onClick={() => setIsSearchOpen(true)} className="hover:opacity-50 transition-opacity" data-id="element-140">
            <SearchIcon className="w-5 h-5 stroke-[1.5px]" data-id="element-141" />
          </button>
          <button onClick={() => setIsCartOpen(true)} className="hover:opacity-50 transition-opacity relative" data-id="element-142">
            <ShoppingBagIcon className="w-5 h-5 stroke-[1.5px]" data-id="element-143" />
            <span className="absolute -top-1 -right-1 text-[8px] font-bold bg-black text-white w-3.5 h-3.5 rounded-full flex items-center justify-center" data-id="element-144">
              0
            </span>
          </button>
        </div>
      </div>

      {/* Mega Menu Nav */}
      <nav className="hidden lg:block border-t border-grey-divider" data-id="element-145">
        <div className="max-w-[1800px] mx-auto px-6 flex items-center justify-center space-x-12" data-id="element-146">
          <Link to="/lookbook" className="py-4 text-[10px] font-display font-bold uppercase tracking-widest hover:opacity-50 transition-opacity" data-id="element-147">
            Lookbook
          </Link>
          {megaMenuData.map(group => <div key={group.title} className="group py-4" onMouseEnter={() => setActiveMenu(group.title)} onMouseLeave={() => setActiveMenu(null)} data-id="element-148">
              <button className="flex items-center space-x-1 text-[10px] font-display font-bold uppercase tracking-widest group-hover:opacity-50 transition-opacity" data-id="element-149">
                <span data-id="element-150">{group.title}</span>
                <ChevronDownIcon className="w-3 h-3 transition-transform group-hover:rotate-180" data-id="element-151" />
              </button>

              {/* Mega Menu Dropdown */}
              <div className="absolute left-0 top-full w-full bg-white border-b border-grey-divider opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-40" data-id="element-152">
                <div className="max-w-[1800px] mx-auto px-6 py-12 grid grid-cols-4 gap-8" data-id="element-153">
                  <div className="col-span-1" data-id="element-154">
                    <h4 className="text-[9px] font-display text-black/40 mb-6 tracking-widest uppercase" data-id="element-155">
                      Shop {group.title}
                    </h4>
                    <ul className="space-y-4" data-id="element-156">
                      {group.items.map(item => <li key={item} data-id="element-157">
                          <Link to={`/${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-[11px] font-display uppercase tracking-widest hover:pl-2 transition-all duration-300 block" data-id="element-158">
                            {item}
                          </Link>
                        </li>)}
                    </ul>
                  </div>
                  <div className="col-span-3 grid grid-cols-3 gap-4" data-id="element-159">
                    {group.images.map((img, i) => <div key={i} className="aspect-[3/4] bg-grey-divider overflow-hidden relative group/img" data-id="element-160">
                        <img src={img.url} alt={img.label} className="w-full h-full object-cover grayscale contrast-125 group-hover/img:scale-105 group-hover/img:grayscale-0 transition-all duration-700" data-id="element-161" />
                        <div className="absolute inset-0 bg-black/10 group-hover/img:bg-black/0 transition-colors" data-id="element-162" />
                        <div className="absolute bottom-4 left-4 text-[9px] font-display tracking-widest uppercase text-white drop-shadow-md" data-id="element-163">
                          {img.label}
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </nav>

      {/* Search Modal Overlay */}
      <AnimatePresence data-id="element-164">
        {isSearchOpen && <div className="fixed inset-0 z-[110] flex items-start justify-center pt-20 px-6" data-id="element-165">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsSearchOpen(false)} className="absolute inset-0 bg-black/40 backdrop-blur-sm" data-id="element-166" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: -20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: -20
        }} className="relative w-full max-w-3xl bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-167">
              {/* Search Input Area */}
              <div className="p-8 flex items-center space-x-4 border-b border-grey-divider" data-id="element-168">
                <SearchIcon className="w-6 h-6 text-black/30" data-id="element-169" />
                <input autoFocus type="text" placeholder="Search products, collections, fabrics..." className="flex-1 text-xl font-light outline-none placeholder:text-black/20" onKeyDown={e => e.key === 'Escape' && setIsSearchOpen(false)} data-id="element-170" />
                <button onClick={() => setIsSearchOpen(false)} className="p-2 hover:bg-black/5 rounded-full transition-colors" data-id="element-171">
                  <XIcon className="w-6 h-6 text-black/30" data-id="element-172" />
                </button>
              </div>

              {/* Popular Searches Area */}
              <div className="p-8 bg-white" data-id="element-173">
                <h4 className="text-[10px] font-display text-black/40 tracking-widest uppercase mb-6" data-id="element-174">
                  Popular Searches
                </h4>
                <div className="flex flex-wrap gap-3" data-id="element-175">
                  {popularSearches.map(tag => <button key={tag} className="px-6 py-2.5 bg-grey-divider/30 hover:bg-grey-divider/60 rounded-full text-[11px] font-display font-bold tracking-widest transition-colors" data-id="element-176">
                      {tag}
                    </button>)}
                </div>
              </div>

              {/* Modal Footer */}
              <div className="px-8 py-6 bg-grey-divider/10 flex items-center justify-between" data-id="element-177">
                <div className="flex items-center space-x-2 text-[10px] font-display tracking-widest text-black/40 uppercase" data-id="element-178">
                  <span data-id="element-179">Press</span>
                  <span className="px-2 py-1 bg-white border border-grey-divider rounded-md text-black font-bold" data-id="element-180">
                    ESC
                  </span>
                  <span data-id="element-181">to close</span>
                </div>
                <button className="bg-black text-white px-10 py-3 rounded-xl text-[11px] font-display font-bold tracking-widest hover:bg-black/80 transition-colors uppercase" data-id="element-182">
                  Search
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Shopping Cart Drawer */}
      <AnimatePresence data-id="element-183">
        {isCartOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsCartOpen(false)} className="fixed inset-0 z-[120] bg-black/40 backdrop-blur-sm" data-id="element-184" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed right-0 top-0 h-full w-full max-w-md bg-white z-[130] shadow-2xl flex flex-col" data-id="element-185">
              <div className="p-6 border-b border-grey-divider flex items-center justify-between" data-id="element-186">
                <h2 className="text-sm font-display font-bold tracking-widest uppercase" data-id="element-187">
                  Shopping Bag (0)
                </h2>
                <button onClick={() => setIsCartOpen(false)} className="p-2 hover:bg-black/5 rounded-full transition-colors" data-id="element-188">
                  <XIcon className="w-5 h-5" data-id="element-189" />
                </button>
              </div>

              <div className="flex-grow flex flex-col items-center justify-center p-12 text-center" data-id="element-190">
                <ShoppingBagIcon className="w-12 h-12 text-black/10 mb-6 stroke-[1px]" data-id="element-191" />
                <p className="text-[10px] font-display tracking-[0.3em] uppercase text-black/40 mb-8" data-id="element-192">
                  Your bag is currently empty
                </p>
                <Link to="/collection/new-in" onClick={() => setIsCartOpen(false)} className="bg-black text-white px-10 py-4 text-[10px] font-display font-bold uppercase tracking-widest hover:bg-black/80 transition-colors" data-id="element-193">
                  Start Shopping
                </Link>
              </div>

              <div className="p-8 border-t border-grey-divider bg-grey-divider/5" data-id="element-194">
                <div className="flex justify-between items-center mb-6" data-id="element-195">
                  <span className="text-[10px] font-display tracking-widest uppercase text-black/40" data-id="element-196">
                    Subtotal
                  </span>
                  <span className="text-sm font-display font-bold" data-id="element-197">$0.00</span>
                </div>
                <button className="w-full bg-black text-white py-5 text-[11px] font-display font-bold uppercase tracking-[0.3em] hover:bg-black/80 transition-colors disabled:opacity-40 disabled:cursor-not-allowed" disabled data-id="element-198">
                  Checkout
                </button>
                <p className="text-center mt-4 text-[9px] font-display tracking-widest uppercase text-black/30" data-id="element-199">
                  Shipping & taxes calculated at checkout
                </p>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-200">
        {isMobileMenuOpen && <motion.div initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-[100] bg-white flex flex-col md:hidden" data-id="element-201">
            <div className="h-20 px-6 flex items-center justify-between border-b border-grey-divider" data-id="element-202">
              <h1 className="text-xl font-display font-bold tracking-[0.4em] uppercase" data-id="element-203">
                Djili
              </h1>
              <button onClick={() => setIsMobileMenuOpen(false)} className="p-2" data-id="element-204">
                <XIcon className="w-6 h-6 stroke-[1.5px]" data-id="element-205" />
              </button>
            </div>

            <div className="flex-grow overflow-y-auto px-6 py-8" data-id="element-206">
              <nav className="space-y-8" data-id="element-207">
                <Link to="/lookbook" onClick={() => setIsMobileMenuOpen(false)} className="block text-lg font-display font-bold uppercase tracking-widest" data-id="element-208">
                  Lookbook
                </Link>

                {megaMenuData.map(group => <div key={group.title} className="space-y-4" data-id="element-209">
                    <h4 className="text-[10px] font-display text-black/40 tracking-widest uppercase" data-id="element-210">
                      {group.title}
                    </h4>
                    <ul className="space-y-4 pl-4" data-id="element-211">
                      {group.items.map(item => <li key={item} data-id="element-212">
                          <Link to={`/${item.toLowerCase().replace(/\s+/g, '-')}`} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-display uppercase tracking-widest block" data-id="element-213">
                            {item}
                          </Link>
                        </li>)}
                    </ul>
                  </div>)}
              </nav>
            </div>

            <div className="p-6 border-t border-grey-divider bg-grey-divider/10" data-id="element-214">
              <a href="tel:5718423307" className="flex items-center space-x-3 mb-6" data-id="element-215">
                <PhoneIcon className="w-5 h-5 stroke-[1.5px]" data-id="element-216" />
                <span className="text-xs font-display tracking-widest uppercase" data-id="element-217">
                  (571) 842-3307
                </span>
              </a>
              <div className="flex space-x-6" data-id="element-218">
                <a href="#" className="text-[10px] font-display tracking-widest uppercase text-black/50" data-id="element-219">
                  Instagram
                </a>
                <a href="#" className="text-[10px] font-display tracking-widest uppercase text-black/50" data-id="element-220">
                  Pinterest
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}